import React from 'react'
import { Tooltip } from 'hljd'
const style = {
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 3,
  overflow: 'hidden',
  textOverflow: 'ellipsis'
}
export default store => [
  {
    title: <span>人群（{store.customerCount}）</span>,
    key: 'group',
    width: '30%',
    render: ({ group }) => (
      <Tooltip title={group}>
        <span style={{ ...style }}>{group}</span>
      </Tooltip>
    )
  },
  {
    title: '发送方式',
    key: 'mode',
    render: ({ type }) => ({ '1': '私信', '2': '活动弹窗', '3': '短信' }[type])
  },
  {
    title: '内容',
    key: 'content',
    width: ' 60%',
    render: ({ content }) => (
      <Tooltip title={content}>
        <span style={{ ...style }}>{content}</span>
      </Tooltip>
    )
  }
]
